import { gql } from '@apollo/client';
import { useSubscription } from '@apollo/client/react';

export const NOTIFICATION_ADDED_SUBSCRIPTION = gql`
  subscription OnNotificationAdded {
    notificationAdded {
      id
      message
      type
      created_at
    }
  }
`;

interface NotificationAddedData {
  notificationAdded: {
    id: string;
    message: string;
    type: 'success' | 'error' | 'info' | 'warning';
    created_at: string;
  };
}

/**
 * A hook to listen for real-time live notifications from the backend subscription.
 * Displays notifications as toast alerts using the global window.showToast helper.
 */
export function useLiveNotifications() {
  const token = localStorage.getItem('auth_token');
  useSubscription<NotificationAddedData>(NOTIFICATION_ADDED_SUBSCRIPTION, {
    skip: !token,
    onData: ({ data }) => {
      const notification = data.data?.notificationAdded;
      if (notification && (window as any).showToast) {
        (window as any).showToast(notification.message, notification.type);
      }
    },
  });
}
